import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'tt-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.css'],
})
export class BreadcrumbsComponent {
    @HostBinding('attr.role')
    public role = 'navigation';
}
